var map = {
	"./musical-soho-playlist-to-suit-your-mood.js": [
		2851,
		851
	],
	"./which-are-you-a-leader.js": [
		6996,
		996
	],
	"./who-are-you-in-the-company-of-friends.js": [
		9253,
		253
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5453;
module.exports = webpackAsyncContext;